// store/middleware/ordersCacheMiddleware.ts
import { Middleware } from '@reduxjs/toolkit'
import { saveToStorage } from '../../common/utils/functions/localStorage'
import { getCacheVersion } from '../../config/runtimeConfig'

export const ordersCacheMiddleware: Middleware = (store) => (next) => (action: any) => {
  const result = next(action)

  if (action.type === 'orderList/setOrders') {
    const orders = store.getState().orderList.data
    
    if (orders) {
      try {
        const version = getCacheVersion()
        const CACHE_KEY = `orders_v${version}`
        saveToStorage(CACHE_KEY, orders)
      } catch (error) {
        console.error('Ошибка сохранения кэша заказов:', error)
      }
    }
  }

  return result
}